import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'vds-horizontal-icon-list',
  styleUrl: 'vds-horizontal-icon-list.scss',
  shadow: true,
})
export class VdsHorizontalIconList {

  /**
   * Sets the columns in a grid layout
   * (value must be between 1 and 12)
   */
  @Prop({ reflect: true }) gridCols: number = 2;
  /**
   * Sets the columns in a grid layout for tablet portrait
   * (value must be between 1 and 12)
   */
  @Prop({ reflect: true }) smGridCols: number = 3;
  /**
   * Sets the columns in a grid layout for tablet horizontal
   * (value must be between 1 and 12)
   */
  @Prop({ reflect: true }) mdGridCols: number = 8;

  render() {
    return (
      <Host>
        <div class="grid gap-3">
          <slot></slot>
        </div>
      </Host>
    );
  }

}
